import React from "react";
import "./appointment.css";
import { useNavigate } from "react-router-dom";
import img from "../Assets/doctor-meeting.png";
function Appointment() {
  const navigate = useNavigate();
  return (
    <div className="appointment">
      <div>
        <h2>Many Specialties, One Mission</h2>
        <p className="below-content">
          <p>That’s</p> <span>You</span>
        </p>
      </div>
      <div className="appointment-section">
        <div>
          <img src={img} alt="img" />
        </div>
        <div className="appointment-right">
          <p>
            At Shri Adithya Hospitals, we are a conglomerate of expert doctors
            who ensure comprehensive treatment through collaboration, advanced
            technology, and evidence based practices. Your health and well-being
            are the foundation of our care.
          </p>
          <button
          onClick={() =>navigate('./', { state: { scrollTo: 'appointment-section' } })}
          >Book Appointment</button>
        </div>
      </div>
    </div>
  );
}

export default Appointment;
